import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { Tables } from '@/_constants/database.types';

type UserData = Tables<'users'>;

const useCurrentUser = () => {
  const client = supabaseClient;

  return useQuery({
    queryKey: ['user'],
    queryFn: () => getCurrentUser(client),
    retry: false,
  });
};

export default useCurrentUser;

async function getCurrentUser(client: SupabaseClient): Promise<UserData | null> {
  const {
    data: { user },
  } = await client.auth.getUser();

  if (!user) {
    return null;
  }

  const { data, error } = await client.from('users').select('*').eq('auth_id', user.id).single();

  if (error) {
    throw new Error(error.message);
  }

  return data;
}
